import React, { useEffect, useState } from "react";
import { client, clientV2 } from "../services/api";
import UnderMaintenance from "../pages/Maintenance/UnderMaintenance";

const MaintenancePageProvider = ({ children }) => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const resInterceptor = res => res;

        const errInterceptor = err => {
            const maintenanceHeader = err?.response?.headers['siteundermaintenance'];
            if (maintenanceHeader === 'true') {
                setEnabled(true);
            }
            return Promise.reject(err);
        };

        // Add interceptors to both clients
        const interceptor1 = client.interceptors.response.use(resInterceptor, errInterceptor);
        const interceptor2 = clientV2.interceptors.response.use(resInterceptor, errInterceptor);

        return () => {
            client.interceptors.response.eject(interceptor1);
            clientV2.interceptors.response.eject(interceptor2);
        };
    }, []);

    if (enabled) {
        return <UnderMaintenance />;
    }

    return children;
};

export default MaintenancePageProvider;
